import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../Dashboard/_services/users.service';
import { AlertService } from '../../Dashboard/_services/alert.service';

// Purchase orders, shipments and suppliers: the PURCHASE role and S-ADMIN.
// (Previously S-ADMIN only, before that one hardcoded email.)
export const purchasesGuard = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const alertService = inject(AlertService);
  const userInfo = userService.isLoggedIn();
  const roles = (userInfo.userrole ?? '').split(',').map((r: string) => r.trim());
  if (userInfo.isLoggedIn && (roles.includes('PURCHASE') || roles.includes('S-ADMIN'))) {
    return true;
  }
  alertService.alert('You do not have permission to access this page', 'error');
  return router.navigate(['/sales']);
};
